
export const propertyLabels: { [key: string]: { label: string; ordem?: number }; } = {

    nome: { label: "Nome", ordem: 1 },
    cpf: { label: "CPF", ordem: 2 },
    email: { label: "Email", ordem: 3 },
    descricaoPermissao: { label: "Permissao", ordem: 4 },
    descricaoStatus: { label: "Status", ordem : 5 }
};

export const modalTitulo = "Colaborador";
export const modalTexto = "Deseja remover o colaborador?"
export const UrlColaborador = "Colaborador";
export const UrlBuscarPorId = "Colaborador/BuscarPorId"
export const UrlBuscarPorIdUsuario = "Colaborador/BuscarPorIdUsuario";
export const UrlBuscarPaginado = "Colaborador/BuscarPaginado";
export const UrlBuscarPermissao = "Permissao";
export const TipoCliente = "3";
export const TipoColaborador = "2"
